import { TransfersBlotter } from '@src/containers/Blotters/Transfers';
import type { TransfersBlotterPanelConfig } from '@src/types/LayoutConfig';
import { MixpanelEventSource, MixpanelSourceProvider } from '@talos/kyoko';
import type { LayoutPanelProps } from '../../../types';
import { BlotterPanel } from './BlotterPanel';

export function TransfersPanel({ params, api }: LayoutPanelProps<TransfersBlotterPanelConfig>) {
  return (
    <MixpanelSourceProvider value={MixpanelEventSource.TransferBlotter}>
      <BlotterPanel
        panelApi={api}
        panelTabs={params.tabs}
        panelBlottersState={params.blotterTablesState}
        data-testid="transfers-blotter-panel"
      >
        <TransfersBlotter />
      </BlotterPanel>
    </MixpanelSourceProvider>
  );
}
